<template>
  <div class="d-flex flex-column align-center">
    <v-progress-circular
      :model-value="rate"
      :color="accessRateColor(rate)"
      bg-color="#e0e0e0"
      :size="size ?? 64"
      :width="width ?? 8"
    >
      <span class="text-caption font-weight-bold">{{ Math.round(rate) }}%</span>
    </v-progress-circular>
    <span class="text-caption text-medium-emphasis mt-1">{{ label ?? 'Taxa de acesso' }}</span>
  </div>
</template>

<script lang="ts">
export type AccessRateLevel = 'success' | 'warning' | 'error'

const ACCESS_RATE_SUCCESS_THRESHOLD = 75
const ACCESS_RATE_WARNING_THRESHOLD = 50

export function accessRateColor(rate: number): AccessRateLevel {
  if (rate >= ACCESS_RATE_SUCCESS_THRESHOLD) return 'success'
  if (rate >= ACCESS_RATE_WARNING_THRESHOLD) return 'warning'
  return 'error'
}
</script>

<script lang="ts" setup>
interface Props {
  rate: number
  size?: number
  width?: number
  label?: string
}

defineProps<Props>()
</script>
